import React from 'react';
import { Button } from './ui/button';
import { services } from '../data/mock';
import { Moon, Sun, Calendar, ArrowRight } from 'lucide-react';

const iconMap = {
  Moon,
  Sun,
  Calendar
};

const ServicesSection = ({ onGetQuote }) => {
  return (
    <section id="services" className="py-16 md:py-24 bg-stone-50" aria-label="Dog Boarding Services Baltimore">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="inline-block bg-amber-100 text-amber-700 font-semibold text-sm px-4 py-1.5 rounded-full mb-4">
            Our Dog Boarding Services
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-stone-800 mb-4">
            Baltimore Dog Boarding Services – Loving Care for Every Need
          </h2>
          <p className="text-lg text-stone-600 max-w-2xl mx-auto">
            Whether you need <strong>overnight dog boarding</strong>, <strong>doggy daycare in Baltimore</strong>, or an extended vacation stay, your pup will receive the same loving attention from our background-checked team.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <article
                key={service.id}
                className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 border border-stone-100"
              >
                {/* Image */}
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={service.image}
                    alt={`${service.title} - Dog Boarding Baltimore MD`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                    width="400"
                    height="192"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                  <div className="absolute bottom-4 left-4 w-12 h-12 bg-white rounded-xl flex items-center justify-center shadow-lg">
                    <IconComponent className="w-6 h-6 text-amber-600" aria-hidden="true" />
                  </div>
                </div>
                
                {/* Content */}
                <div className="p-6">
                  <h3 className="text-xl font-bold text-stone-800 mb-3">{service.title} in Baltimore</h3>
                  <p className="text-stone-600 leading-relaxed mb-4">{service.description}</p>
                  <button
                    onClick={onGetQuote}
                    className="inline-flex items-center text-amber-600 font-semibold hover:text-amber-700 group/btn"
                    aria-label={`Get a quote for ${service.title}`}
                  >
                    Get a Quote
                    <ArrowRight className="ml-2 w-4 h-4 group-hover/btn:translate-x-1 transition-transform" aria-hidden="true" />
                  </button>
                </div>
              </article>
            );
          })}
        </div>

        {/* CTA Banner */}
        <div className="mt-12 text-center">
          <Button
            onClick={onGetQuote}
            className="bg-amber-500 hover:bg-amber-600 text-white font-semibold px-8 py-6 text-lg rounded-xl shadow-lg hover:shadow-xl transition-all"
          >
            Get Your Free Quote Today
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
